import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

const RoundedGrid = ({ items, isClickable, wrapDirection = 'wrap', cardWidth, cardHeight }) => (
  <S.RoundedGrid $wrapDirection={wrapDirection}>
    {items.map(item => (
      <S.Card
        key={item.key}
        $disabled={item.disabled}
        $isClickable={isClickable}
        $selected={item.selected}
        $width={cardWidth}
        $height={cardHeight}>
        {item.element}
      </S.Card>
    ))}
  </S.RoundedGrid>
);

RoundedGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      disabled: PropTypes.bool,
      selected: PropTypes.bool,
      element: PropTypes.node
    })
  ).isRequired,
  isClickable: PropTypes.bool,
  wrapDirection: PropTypes.string,
  cardWidth: PropTypes.number,
  cardHeight: PropTypes.number
};

export default RoundedGrid;
